module.exports = __webpack_public_path__ + "img/banner-bg-6.eb0f20a2.png";